
import { mapState } from "vuex";

import { debounce } from "~/utils/underscore-utils";

const SEARCH_DEBOUNCE_DELAY = 300;

export default {
  name: "SearchBarCenter",

  directives: {
    focus: {
      inserted(el) {
        el.focus();
      },
    },
  },

  data() {
    return {
      suggestion: null,
      suggestions: [],
      redirect: "",
      currentQuery: "",
      products: [],
      blogs: [],
      debouncedSearch: () => {},
    };
  },

  computed: {
    ...mapState(["siteConfig"]),
    ...mapState("app", ["isSearchOpen"]),
  },

  created() {
    this.debouncedSearch = debounce(this.search, SEARCH_DEBOUNCE_DELAY);
  },

  beforeDestroy() {
    // Cancel any pending debounced calls
    if (this.debouncedSearch?.cancel) {
      this.debouncedSearch.cancel();
    }
  },

  methods: {
    closeSearch() {
      const payload = {
        title: [{ text: "Search" }],
        url: "from search",
      };

      this.$store.dispatch("app/setRedirectFrom", payload);
      this.$store.dispatch("app/closeSearch", this.isTablet);
      this.currentQuery = "";
    },

    async search() {
      try {
        const [productsData, blogsData] = await Promise.all([
          this.$search.productsAutocomplete(this.currentQuery, 6),
          this.$search.blogsAutocomplete(this.currentQuery, 3),
        ]);

        this.blogs = (blogsData.data.results ?? []).map(blog =>
          this.getBlogProps(blog)
        );
        this.products = (productsData.data.results ?? []).map(product =>
          this.getProductProps(product)
        );
        this.redirect = productsData.data.merchandising.redirect;
        this.suggestion = productsData.suggestions[0];
        this.suggestions = productsData.suggestions;
      } catch (err) {
        this.$bugsnag.notify(err);
      }
    },

    handleInputChange(event) {
      this.currentQuery = event.currentTarget.value;
      if (this.currentQuery !== "") {
        this.$store.dispatch("app/openSearch", this.isTablet);
      } else {
        this.closeSearch();
      }
      this.debouncedSearch();
    },

    handleSubmit(event) {
      const searchedValue = event.target.search.value;
      this.$gtm.gtagEvent("search", { search_term: searchedValue });

      if (!searchedValue) {
        return;
      }

      if (this.redirect || this.products.length > 0) {
        const location = this.redirect
          ? { path: this.redirect }
          : { path: "/products/search", query: { query: searchedValue } };
        this.$router.push(location);
        this.closeSearch();
      }
    },
    getBlogProps({ name: title, imageUrl: image, handle, ...rest }) {
      return {
        ...rest,
        title,
        image,
        url: `/blogs/inspiration/${handle}`,
      };
    },
    getProductProps({ handle, selectedVariant, ...rest }) {
      return {
        ...rest,
        url: `/products/${handle}?variant=${selectedVariant?.id}`,
      };
    },
  },
};
